import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PROFILE } from "../../constants/profile";

const WeekendModeContent = () => {
  const [isWeekendMode] = useState(false);

  return (
    <>
      <div
        className={`salva-weekend-mode ${isWeekendMode ? "checked" : ""}`}
        id="weekend_mode"
      >
        <div className="salv-inrto-content">
          <h5 className="salv-about-title salv-home-title md-font w-text inter-font-900 mb-0">
            Me on Weekends
          </h5>
        </div>
        <div className="salv-week-desc">
          <p className="mt-0 mb-0 sal-week-desc-one inter-font-400 sm-md-font-two">
            When the weekend starts, I switch from coding to gaming. I love
            playing top PC games and trying new titles that push graphics,
            story, and gameplay.
          </p>
          <p className="mb-0 mt-0 sal-week-desc-two inter-font-400 sm-md-font-two">
            Gaming is one of my favorite ways to relax. I enjoy long sessions,
            exploring open worlds, and playing competitive games with friends
            online.
          </p>
          <p className="mt-0 mb-0 sal-week-desc-three inter-font-400 sm-md-font-two">
            It keeps me creative, helps me unwind, and reminds me why I love
            technology both at work and outside of it.
          </p>
        </div>
        <div className="salv-drop-mail">
          <div className="salv-drop-mail-wrap">
            <h6 className="mb-0 drop-mail-title inter-font-400 w-text">
              Drop Your Mail:
            </h6>
            <Link
              style={{ color: "white" }}
              to={`mailto:${PROFILE.email}`}
              className="salv-mail-text inter-font-900 w-text"
            >
              &nbsp;{PROFILE.email}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default WeekendModeContent;
